import { IconReply } from '@consta/icons/IconReply'
import { Button } from '@consta/uikit/Button'
import { Switch } from '@consta/uikit/Switch'
import type { TableColumn } from '@consta/uikit/Table'
import { Text } from '@consta/uikit/Text'
import type { ProjectWellVsp } from '@core/core/types'

import { titleCellRender } from '../../table'
import type { OnApplyVspFunc, OnSwitchActiveVspFunc, RowVsp } from '../../types'

export const getVspTableColumns = (
  hoveredRowId: string | undefined,
  actionLabel: string,
  onApplyVsp: OnApplyVspFunc,
  onSetActiveProjectVsp?: OnSwitchActiveVspFunc,
): TableColumn<RowVsp>[] => {
  const showSwitch = onSetActiveProjectVsp != null
  return [
    {
      title: titleCellRender('Скоростной закон'),
      accessor: 'vspName',
      width: 180,
      renderCell: ({ vspName }) => (
        <Text size="s" truncate={true} view="primary">
          {vspName}
        </Text>
      ),
    },
    {
      title: titleCellRender('Активность'),
      accessor: 'isActive',
      align: 'left',
      hidden: !showSwitch,
      renderCell: ({ id, vspId, isActive }) => (
        <Switch
          size="s"
          checked={isActive}
          style={{
            visibility: isActive || id === hoveredRowId ? 'initial' : 'hidden',
          }}
          onChange={onSetActiveProjectVsp?.(vspId, isActive)}
        />
      ),
    },
    {
      title: titleCellRender('Действия'),
      accessor: 'action',
      align: 'right',
      renderCell: vsp => {
        const { id } = vsp
        return (
          <Button
            size="xs"
            label={actionLabel}
            view="ghost"
            iconLeft={IconReply}
            style={{
              visibility: hoveredRowId === id ? 'initial' : 'hidden',
            }}
            onClick={onApplyVsp(vsp)}
          />
        )
      },
    },
  ]
}

export const transformWellVspToRows = (wellVsp: ProjectWellVsp | undefined) =>
  wellVsp?.vspList.map<RowVsp>(vsp => ({
    action: null,
    ...vsp,
  })) ?? []
